import PaginationControlsComponent from './PaginationControlsComponent';
export * from './PaginationControlsComponent';
export default PaginationControlsComponent;
